import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DayViewResponse, PutDayAllocationsRequest, PutDayAllocationsResponse } from './day.model';

/**
 * Service for fetching today's day view data from the backend API.
 *
 * This service provides a method to retrieve the current day's data, including settings,
 * allocations, blocks, and habits.
 *
 * @author sadatmalik
 */
@Injectable({ providedIn: 'root' })
export class DayService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/days`;

  getToday(): Observable<DayViewResponse> {
    return this.http.get<DayViewResponse>(`${this.baseUrl}/today`);
  }

  putAllocations(dayDate: string, request: PutDayAllocationsRequest): Observable<PutDayAllocationsResponse> {
    return this.http.put<PutDayAllocationsResponse>(`${this.baseUrl}/${dayDate}/allocations`, request);
  }

  patchAllocationHidden(dayDate: string, activityTypeId: string, hidden: boolean): Observable<DayViewResponse> {
    return this.http.patch<DayViewResponse>(
      `${this.baseUrl}/${dayDate}/allocations/${activityTypeId}/hidden`,
      { hidden }
    );
  }
}
